import axios from 'axios';
import { AppConfig } from './appConfig';

let appConfig: AppConfig = {} as any;

const loadConfig = axios('/assets/appConfig.json', {
	method: 'get'
})
.then(res => res.data)
.then(cfg => {
	appConfig = cfg;
});

export const config = () => {
	return appConfig;
};

export default loadConfig;
